const keys = {
  // Pfiffiner
  256999: {
    key: 256999,
    compradoresResponsaveis: {
      visivel: true,
      hasFilter: false,
      stringFilter: false,
      isProduto: false,
      valorPadrao: [
        {
          cpf: null,
          email: 'marcio.boing@pfiffner.com.br',
          nome: 'Marcio Boing',
          enabled: true,
          id: 3219,
          telefone: '(47) 99945-0328',
          whatsapp: '(47) 99945-0328',
        },
      ],
    },
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
